import { Button, IconButton } from '@material-ui/core';
import { AddComment, Close, OpenInNew } from '@material-ui/icons';
import * as React from 'react';

import { useAgent } from '../../hooks/use-agent';

export const AgentHeaderActions: React.FC<{
    variant?: 'page' | 'sidebar';
}> = ({ variant = 'page' }) => {
    const { onClose, onNewChat, hasActiveChat, conversationId } = useAgent();

    const actionNodes: React.ReactNode[] = [];

    if (variant === 'sidebar') {
        if (hasActiveChat) {
            actionNodes.push(
                <Button
                    key="new-chat"
                    size="small"
                    color="inherit"
                    onClick={onNewChat}
                    startIcon={<AddComment fontSize="small" />}
                    aria-label="Start a new chat conversation"
                >
                    New Chat
                </Button>
            );
        }

        const handleOpenOrbit = () => {
            const link = conversationId ? `/orbit/chat/${conversationId}` : '/orbit';
            window.open(link, '_blank', 'noopener,noreferrer');
        };

        actionNodes.push(
            <IconButton key="open" size="small" onClick={handleOpenOrbit} aria-label="Open full agent">
                <OpenInNew fontSize="small" />
            </IconButton>
        );

        if (onClose) {
            actionNodes.push(
                <IconButton key="close" size="small" onClick={onClose} aria-label="Close agent sidebar">
                    <Close fontSize="small" />
                </IconButton>
            );
        }
    }

    return actionNodes.length > 0 ? <div className="agent__headerActions">{actionNodes}</div> : null;
};
